import React from 'react';

const Footer = () => {
  return (
    <footer className="app-footer">
      <p>© 2025 Theertana Mahligai. All rights reserved.</p>
      <p>Empowered by Rugha Throne Tha Professor.</p>
    </footer>
  );
};

export default Footer;